import { render, staticRenderFns } from "./AvatarCellRenderer.vue?vue&type=template&id=5b309460&"
import script from "./AvatarCellRenderer.vue?vue&type=script&lang=ts&"
export * from "./AvatarCellRenderer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports